import { readFileSync } from "node:fs";
import path from "node:path";
import { fileURLToPath } from "node:url";

import { z } from "zod";

const packageMetadataSchema = z.object({
  name: z.string().trim().min(1),
  version: z.string().trim().min(1),
  description: z.string().trim().min(1),
});

export type PackageMetadata = z.infer<typeof packageMetadataSchema>;

function loadPackageMetadata(): PackageMetadata {
  const currentFilePath = fileURLToPath(import.meta.url);
  const currentDir = path.dirname(currentFilePath);
  const packageJsonPath = path.resolve(currentDir, "../package.json");

  let rawPackageJson = "";
  try {
    rawPackageJson = readFileSync(packageJsonPath, "utf-8");
  } catch (error) {
    throw new Error(
      `[primeui-mcp] failed to read package.json at ${packageJsonPath}: ${
        error instanceof Error ? error.message : String(error)
      }`,
    );
  }

  let parsedPackageJson: unknown;
  try {
    parsedPackageJson = JSON.parse(rawPackageJson) as unknown;
  } catch (error) {
    throw new Error(
      `[primeui-mcp] invalid package.json at ${packageJsonPath}: ${
        error instanceof Error ? error.message : String(error)
      }`,
    );
  }

  const parsed = packageMetadataSchema.safeParse(parsedPackageJson);
  if (!parsed.success) {
    const details = parsed.error.issues
      .map((issue) => `${issue.path.join(".") || "<root>"}: ${issue.message}`)
      .join("; ");
    throw new Error(
      `[primeui-mcp] invalid package metadata in ${packageJsonPath}: ${details}`,
    );
  }

  return parsed.data;
}

export const packageMetadata = loadPackageMetadata();
